// Existing feature flags
const isMonitoringEnabled = () =>
  ["production"].includes(process.env.GATSBY_ENV) && !process.env.GATSBY_IS_MONITORING_DISABLED;

const isLivePreviewEnabled = ["dev"].includes(process.env.GATSBY_ENV);

const isBetaVersionEnabled = !!process.env.GATSBY_PATH_PREFIX;

const isMultiLanguageEnabled = () =>
  process.env.GATSBY_LOCALE === "true" || ["dev", "staging"].includes(process.env.GATSBY_ENV);

const getEnabledLocales = () => (isMultiLanguageEnabled() ? ["en-us", "es-us"] : ["en-us"]);

module.exports = {
  isMonitoringEnabled,
  isLivePreviewEnabled,
  isBetaVersionEnabled,
  isMultiLanguageEnabled,
  getEnabledLocales,
};
